import type { FaireProductEntity } from "../../entity_types/product";

export const p_23eqsxrjhg: FaireProductEntity = {
  token: "p_23eqsxrjhg",
  type: "product",
  name: "Shower Discovery Set",
  brandToken: "b_3i3gsl3t",
  brandName: "JACK HENRY",
  imageUrl:
    "https://cdn.faire.com/fastly/5d356a94b89d0cdff648d69d665bb4f6273d9c2e9cd62562937fc1efe00a817f.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description:
    "Meet the Shower Discovery Set from JACK HENRY. This set is a part of our plant-based full body care collection, sourced from the purest ingredients on the planet, designed to feed the microbiome and bring balance. As with all our products, this set emphasizes simplicity, transparency, and effectiveness in its formulations. It's carefully crafted with minimal, organic, and sustainably sourced ingredients, free from harmful chemicals. Our dedication to purity and environmental responsibility is reflected in every product.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:11.980Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
